(function() {
    var KEY='dp_visited_pages';
    try {
        var visited=JSON.parse(localStorage.getItem(KEY)||'[]');
        var entry={
            url:window.location.href,
            title:document.title,
            time:new Date().toISOString()
        };
        if(!visited.length||visited[visited.length-1].url!==entry.url) {
            visited.push(entry);
            localStorage.setItem(KEY,JSON.stringify(visited));
        }
    } catch(e) {}
})();

function getVisitedPages() {
    try {
        return JSON.parse(localStorage.getItem('dp_visited_pages')||'[]');
    } catch(e) {
        return [];
    }
}

function dpStripDomain(url) {
    var domain='https://www.datenpioniere.de';
    if(url.indexOf(domain)===0) {
        return url.substring(domain.length)||'/';
    }
    return url.replace(/^https?:\/\//,'');
}

function dpShortenPaths(visited,maxLen) {
    function lastSegment(path) {
        var parts=path.replace(/\/$/,'').split('/');
        return '/'+parts[parts.length-1];
    }

    function isLpPath(path) {
        return path.indexOf('/lp/')===0||path==='/lp';
    }

    function safeTruncate(str,max) {
        if(str.length<=max) return str;
        var cut=str.substring(0,max);
        var lastBoundary=Math.max(cut.lastIndexOf('/'),cut.lastIndexOf('-'));
        if(lastBoundary>0) cut=cut.substring(0,lastBoundary);
        return cut.replace(/-+$/,'');
    }

    var paths=visited.map(function(p) { return dpStripDomain(p.url||''); });
    if(!maxLen) return paths.join('|');

    var joined=paths.join('|');
    if(joined.length<=maxLen) return joined;

    paths=paths.map(function(p) {
        if(isLpPath(p)) return p;
        return lastSegment(p);
    });
    joined=paths.join('|');
    if(joined.length<=maxLen) return joined;

    while(paths.length>1&&paths.join('|').length>maxLen) {
        paths.shift();
    }

    if(paths.length===1&&paths[0].length>maxLen) {
        paths[0]=safeTruncate(paths[0],maxLen);
    }

    return paths.join('|');
}

function setHiddenField(form,name,value) {
    let input=form.querySelector(`input[name="${name}"]`);
    if(!input) {
        input=document.createElement('input');
        input.type='hidden';
        input.name=name;
        form.appendChild(input);
    }
    input.value=value;
}

function showFormMessage(element) {
    if(!element) return;
    element.style.display=element.classList.contains('field-error') ? 'flex' : 'block';
}

function hideFormMessage(element) {
    if(!element) return;
    element.style.display='none';
}

var Webflow=Webflow||[];
Webflow.push(function() {
    const MIN_MESSAGE_LENGTH=100;

    let blockedDomainsLoaded=false;
    let blockedDomainsLoading=false;
    let sharedForbiddenDomains=[];
    let sharedUnwantedDomains=[];

    function loadBlockedDomains() {
        if(blockedDomainsLoaded||blockedDomainsLoading) return;
        blockedDomainsLoading=true;

        fetch('https://tokens.datenpioniere.de/blocked-domains.php?token=BDzk7Wq9Xm3RvL5nTpYs8AeJ1CfH4GuN')
            .then(function(r) { return r.json(); })
            .then(function(data) {
                sharedForbiddenDomains=data.blockedDomains||[];
                sharedUnwantedDomains=data.unwantedDomains||[];
                blockedDomainsLoaded=true;
            })
            .catch(function() {
                blockedDomainsLoaded=true;
            });
    }

    document.addEventListener('focusin',function() {
        loadBlockedDomains();
    },{once:true});

    function isElementVisible(el) {
        if(!el) return false;
        if(el.offsetParent===null) return false;
        const style=window.getComputedStyle(el);
        if(style.visibility==='hidden'||style.display==='none'||parseFloat(style.opacity)===0) return false;
        return true;
    }

    function isEmailSyntaxValid(email) {
        const re=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }

    const PHONE_FAKE_PATTERNS=[
        /^0+$/,
        /^1+$/,
        /^2+$/,
        /^9+$/,
        /^123456(?:7890)?$/,
        /^987654(?:3210)?$/
    ];

    function phoneDigits(value) {
        return (value||'').replace(/\D/g,'');
    }

    function phoneHasRepeatedDigits(digits) {
        if(digits.length<6) return false;
        return /^(\d)\1+$/.test(digits);
    }

    function phoneHasSequentialDigits(digits) {
        if(digits.length<6) return false;
        const sequences=[
            '01234567890123456789',
            '12345678901234567890',
            '98765432109876543210'
        ];
        for(const sequence of sequences) {
            if(sequence.includes(digits)) return true;
        }
        return false;
    }

    // Cheap heuristic that catches the obvious fakes (0, 123456, 1111111111 ...)
    // even when the libphonenumber CDN script is not loaded.
    function isPhoneObviouslyFake(value) {
        const digits=phoneDigits(value);
        if(digits.length===0) return false;
        if(digits.length<6) return true;
        for(const pattern of PHONE_FAKE_PATTERNS) {
            if(pattern.test(digits)) return true;
        }
        if(phoneHasRepeatedDigits(digits)) return true;
        if(phoneHasSequentialDigits(digits)) return true;
        return false;
    }

    // Returns true when the number looks implausible. Uses libphonenumber
    // (global `libphonenumber`, loaded via CDN) when available, otherwise
    // falls back to the heuristic only. Fails open (never flags valid input
    // just because the library is missing).
    function isPhoneImplausible(value,country) {
        const trimmed=(value||'').trim();
        if(trimmed==='') return false;
        if(isPhoneObviouslyFake(trimmed)) return true;

        const lib=window.libphonenumber;
        if(!lib||typeof lib.parsePhoneNumberFromString!=='function') return false;

        let parsed;
        try {
            parsed=lib.parsePhoneNumberFromString(trimmed,country||'DE');
        } catch(e) {
            return true;
        }
        if(!parsed) return true;
        return !parsed.isPossible()||!parsed.isValid();
    }

    function getDomainInfoElement(form) {
        const container=form.parentElement;
        if(container&&container.previousElementSibling&&container.previousElementSibling.classList&&container.previousElementSibling.classList.contains('domain-token-info')) {
            return container.previousElementSibling;
        }

        const wrapper=container?.closest('.form-events');
        if(wrapper) {
            const candidate=wrapper.querySelector('.domain-token-info');
            if(candidate) return candidate;
        }

        return null;
    }

    function initForm(form) {
        if(form.dataset.jsInitialized==='true') return;

        const emailInput=form.querySelector('#business-email, input[type="email"][name="Business-E-Mail"], input[type="email"], #E-Mail, input[name="E-Mail"]');
        const submitButton=form.querySelector('.event_form_button, [type="submit"]');
        const emailErrorEl=form.querySelector('.mail-message, .mail-message-error')||(form.parentElement&&form.parentElement.querySelector('.w-form-fail'));
        const emailUnwantedErrorEl=form.querySelector('.mail-message-unwanted, .unwanted-mail-message-error');
        const errorEl=getDomainInfoElement(form);

        const messageField=form.querySelector('.js-char-counter');
        const counterContainer=form.querySelector('.w-embed .text-message')||form.querySelector('.text-message');
        const charCount=counterContainer?.querySelector('.char-count');
        const charCountLeft=counterContainer?.querySelector('.char-count-left');

        const couponField=form.querySelector('input[name="code"], .js-code, #code');
        let couponErrorEl=form.querySelector('.code-message, .coupon-message, .coupon-message-error');
        if(couponField&&!couponErrorEl) {
            couponErrorEl=document.createElement('div');
            couponErrorEl.className='code-message mail-message';
            couponErrorEl.textContent='Code ist bereits verwendet worden oder ungültig';
            couponErrorEl.style.display='none';
            couponField.insertAdjacentElement('afterend',couponErrorEl);
        }

        const eventTypeEl=form.querySelector('#event-type-field, [name="event-type"]');
        const eventPriceEl=form.querySelector('#event-price-field, [name="event-price"]');
        const eventNameEl=form.querySelector('#event-name-field, [name="event-name"]');

        // Optional phone plausibility check: only runs when BOTH a phone field
        // and a dedicated phone error element exist in the form.
        const phoneField=form.querySelector('input[type="tel"], #Telefon, #Telefonnummer, input[name="Telefon"], input[name="Telefonnummer"], input[name="Phone"], input[name="phone"], .js-phone');
        const phoneErrorEl=form.querySelector('.phone-message, .phone-message-error');
        const phoneCountryEl=form.querySelector('#country, [name="phone-country"], .js-phone-country');
        const phoneChecked=!!(phoneField&&phoneErrorEl);
        // By default the check is a gentle hint and does NOT block submit.
        // Add the class `phone-check-required` to the form to make it blocking.
        const phoneBlocks=form.classList.contains('phone-check-required');
        let phoneValidationTimeout=null;

        const skipUnwanted=form.classList.contains('skip-unwanted-check');
        const skipVisitedPages=form.classList.contains('skip-visited-pages');
        const skipMessageCheck=form.classList.contains('skip-message-check');

        if(!emailInput||!submitButton) return;

        if (emailErrorEl) {
            emailErrorEl.style.display='none';
            emailErrorEl.classList.remove('is-visible');
        }
        if (emailUnwantedErrorEl) {
            emailUnwantedErrorEl.style.display='none';
            emailUnwantedErrorEl.classList.remove('is-visible');
        }
        form.dataset.emailTouched='false';

        function isUnwantedDomain(email) {
            const atIndex=email.lastIndexOf('@');
            if(atIndex===-1) return false;
            const domain=email.substring(atIndex).toLowerCase();
            return sharedUnwantedDomains.includes(domain);
        }

        function isForbiddenDomain(email) {
            const atIndex=email.lastIndexOf('@');
            if(atIndex===-1) return false;
            const domain=email.substring(atIndex).toLowerCase();
            return sharedForbiddenDomains.includes(domain);
        }

        function setSubmitEnabled(enabled) {
            if(!enabled) {
                submitButton.classList.add('is-disabled');
                submitButton.setAttribute('disabled','disabled');
                return;
            }
            submitButton.classList.remove('is-disabled');
            submitButton.removeAttribute('disabled');
        }

        function updateDomainValidation() {
            const email=(emailInput.value||'').trim().toLowerCase();
            const syntaxOk=isEmailSyntaxValid(email);
            const forbidden=isForbiddenDomain(email);
            const unwanted=!skipUnwanted&&isUnwantedDomain(email);
            const touched=form.dataset.emailTouched==='true';
            const invalid=!syntaxOk||forbidden||unwanted;

            if (emailUnwantedErrorEl) {
                emailUnwantedErrorEl.classList.remove('is-visible');
            }
            hideFormMessage(emailUnwantedErrorEl);

            if(touched&&invalid) {
                if(forbidden) {
                    if (emailErrorEl) {
                        emailErrorEl.classList.add('is-visible');
                    }
                    showFormMessage(emailErrorEl);
                } else if(unwanted) {
                    if (emailUnwantedErrorEl) {
                        emailUnwantedErrorEl.classList.add('is-visible');
                    }
                    showFormMessage(emailUnwantedErrorEl);
                } else {
                    if (emailErrorEl) {
                        emailErrorEl.classList.add('is-visible');
                    }
                    showFormMessage(emailErrorEl);
                }
                emailInput.classList.add('is-forbidden');
                emailInput.classList.add('field-input-error');
                form.dataset.domainInvalid='true';
            } else if(!invalid) {
                if (emailErrorEl) {
                    emailErrorEl.classList.remove('is-visible');
                }
                if (emailUnwantedErrorEl) {
                    emailUnwantedErrorEl.classList.remove('is-visible');
                }
                hideFormMessage(emailErrorEl);
                hideFormMessage(emailUnwantedErrorEl);
                emailInput.classList.remove('is-forbidden');
                emailInput.classList.remove('field-input-error');
                form.dataset.domainInvalid='false';
            } else {
                if (emailErrorEl) {
                    emailErrorEl.classList.remove('is-visible');
                }
                if (emailUnwantedErrorEl) {
                    emailUnwantedErrorEl.classList.remove('is-visible');
                }
                hideFormMessage(emailErrorEl);
                hideFormMessage(emailUnwantedErrorEl);
                emailInput.classList.remove('is-forbidden');
                emailInput.classList.remove('field-input-error');
                form.dataset.domainInvalid='true';
            }

            updateSubmitState();
        }

        function updateMessageValidation() {
            if(!messageField) {
                form.dataset.messageInvalid='false';
                updateSubmitState();
                return;
            }

            const length=messageField.value.trim().length;
            const remaining=MIN_MESSAGE_LENGTH-length;

            if(charCountLeft) {
                charCountLeft.textContent=String(remaining>0?remaining:0);
            }

            if(remaining>0) {
                if(counterContainer) {
                    counterContainer.style.display='block';
                }
                form.dataset.messageInvalid='true';
            } else {
                if(counterContainer) {
                    counterContainer.style.display='none';
                }
                form.dataset.messageInvalid='false';
            }

            updateSubmitState();
        }

        function updateSubmitState() {
            const email=(emailInput.value||'').trim().toLowerCase();
            const emailOk=isEmailSyntaxValid(email)&&!isForbiddenDomain(email)&&(skipUnwanted||!isUnwantedDomain(email));
            const msgOk=skipMessageCheck||!messageField||messageField.value.trim().length>=MIN_MESSAGE_LENGTH;
            const couponOk=!couponField||couponField.value.trim().length>0;
            const ok=emailOk&&msgOk&&couponOk;

            setSubmitEnabled(ok);
        }

        if(charCount) {
            charCount.textContent=String(MIN_MESSAGE_LENGTH);
        }
        if(messageField&&charCountLeft) {
            const initialRemaining=Math.max(MIN_MESSAGE_LENGTH-messageField.value.trim().length,0);
            charCountLeft.textContent=String(initialRemaining);
        }

        emailInput.addEventListener('input',function() {
            form.dataset.emailTouched='true';
            updateDomainValidation();
        });
        emailInput.addEventListener('blur',function() {
            form.dataset.emailTouched='true';
            updateDomainValidation();
        });

        if(messageField) {
            messageField.addEventListener('input',updateMessageValidation);
        }

        if(couponField) {
            couponField.addEventListener('input',function() {
                if(couponErrorEl) {
                    couponErrorEl.classList.remove('is-visible');
                }
                hideFormMessage(couponErrorEl);
                updateSubmitState();
            });
        }

        function getPhoneCountry() {
            const val=((phoneCountryEl&&phoneCountryEl.value)||'').trim().toUpperCase();
            return val||'DE';
        }

        function updatePhoneValidation() {
            if(!phoneChecked) return;

            const value=(phoneField.value||'').trim();

            if(value==='') {
                phoneField.classList.remove('field-input-error');
                if(phoneErrorEl) phoneErrorEl.classList.remove('is-visible');
                hideFormMessage(phoneErrorEl);
                form.dataset.phoneInvalid='false';
                return;
            }

            if(isPhoneImplausible(value,getPhoneCountry())) {
                phoneField.classList.add('field-input-error');
                if(phoneErrorEl) phoneErrorEl.classList.add('is-visible');
                showFormMessage(phoneErrorEl);
                form.dataset.phoneInvalid='true';
            } else {
                phoneField.classList.remove('field-input-error');
                if(phoneErrorEl) phoneErrorEl.classList.remove('is-visible');
                hideFormMessage(phoneErrorEl);
                form.dataset.phoneInvalid='false';
            }
        }

        if(phoneChecked) {
            if(phoneErrorEl) {
                phoneErrorEl.classList.remove('is-visible');
                if(!phoneErrorEl.textContent.trim()) {
                    phoneErrorEl.textContent='Deine Telefonnummer sieht nicht ganz richtig aus. Bitte überprüfe sie noch einmal.';
                }
            }
            hideFormMessage(phoneErrorEl);
            form.dataset.phoneInvalid='false';

            phoneField.addEventListener('input',function() {
                window.clearTimeout(phoneValidationTimeout);
                phoneValidationTimeout=window.setTimeout(updatePhoneValidation,400);
            });
            phoneField.addEventListener('blur',function() {
                window.clearTimeout(phoneValidationTimeout);
                updatePhoneValidation();
            });
        }

        hideFormMessage(emailErrorEl);
        hideFormMessage(emailUnwantedErrorEl);
        if (emailErrorEl) {
            emailErrorEl.classList.remove('is-visible');
        }
        updateSubmitState();
        updateMessageValidation();

        form.addEventListener('submit',function(event) {
            if(!skipVisitedPages) {
                var visited=getVisitedPages();
                if(visited.length) {
                    setHiddenField(form,'visited_pages',dpShortenPaths(visited,0));
                    setHiddenField(form,'visited_pages_count',String(visited.length));
                }
            }

            const email=(emailInput.value||'').trim().toLowerCase();

            form.dataset.emailTouched='true';
            updateDomainValidation();

            if(!isEmailSyntaxValid(email)||isForbiddenDomain(email)||(!skipUnwanted&&isUnwantedDomain(email))) {
                event.preventDefault();
                event.stopImmediatePropagation();
                return;
            }

            if(!skipMessageCheck&&messageField&&messageField.value.trim().length<MIN_MESSAGE_LENGTH) {
                event.preventDefault();
                event.stopImmediatePropagation();
                updateMessageValidation();
                return;
            }

            if(phoneBlocks&&phoneChecked) {
                updatePhoneValidation();
                if(form.dataset.phoneInvalid==='true') {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    return;
                }
            }

            if(!email||form.dataset.validated==='true') return;

            const eventType=(eventTypeEl?.value||'').trim().toLowerCase();
            const eventPrice=(eventPriceEl?.value||'').trim();
            const eventName=(eventNameEl?.value||'').trim().toLowerCase();

            if(eventType!=='schulungen'||eventPrice!=='€ 0,-') return;

            event.preventDefault();
            event.stopImmediatePropagation();

            const originalButtonText=submitButton.value;
            submitButton.classList.add('is-disabled');
            submitButton.value=submitButton.getAttribute('data-wait');

            const formData=new FormData();
            formData.append('email',email);

            let type='powerbi';
            if(eventName.includes('fabric')) {
                type='fabric';
            }
            formData.append('type',type);

            if(couponField) {
                formData.append('coupon',couponField.value.trim());
            }

            fetch('https://tokens.datenpioniere.de/check.php?token=TRFFEuo6zwzlAfBcQyGG8CE4eQ22Qgnx',{
                method:'POST',
                body:formData
            }).then(function(response) {
                return response.json();
            }).then(function(data) {
                if(couponField&&!data.valid) {
                    if(couponErrorEl) {
                        couponErrorEl.classList.add('is-visible');
                    }
                    showFormMessage(couponErrorEl);

                    submitButton.classList.remove('is-disabled');
                    submitButton.value=originalButtonText;
                    return;
                }

                if(!data.valid) {
                    setHiddenField(form,'domain_token_allowed','false');
                    if(errorEl) {
                        errorEl.classList.add('visible');
                    }
                }

                if(data.count) {
                    setHiddenField(form,'domain_token_count',data.count);
                }

                submitButton.classList.remove('is-disabled');
                submitButton.value=originalButtonText;

                form.dataset.validated='true';

                form.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));
            }).catch(function() {
                setHiddenField(form,'domain_token_validated','error');

                submitButton.classList.remove('is-disabled');
                submitButton.value=originalButtonText;

                form.dataset.validated='true';

                form.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));
            });
        });

        form.dataset.jsInitialized='true';
    }

    function initVisibleForms() {
        const forms=document.querySelectorAll('form.dp_form, form.event_form, form.js-event-form, form#wf-form-Event-Form, form#wf-form-Exklusiv-Event, form#wf-form-Kontaktformular');
        forms.forEach(function(f) {
            if(isElementVisible(f)) {
                initForm(f);
            }
        });
    }

    initVisibleForms();

    const observer=new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if(entry.isIntersecting) {
                initForm(entry.target);
            }
        });
    },{threshold:0.01});

    document.querySelectorAll('form.dp_form, form.event_form, form.js-event-form, form#wf-form-Event-Form, form#wf-form-Exklusiv-Event, form#wf-form-Kontaktformular').forEach(function(f) {
        observer.observe(f);
    });
});

(function() {
    var COLOR_CLASSES=['availability--green','availability--yellow','availability--red','availability--soldout'];

    function computePlaces(days) {
        if(days<=3) return 2;
        if(days<=7) return 4;
        if(days<=13) return 6;
        if(days<=21) return 9;
        return 14;
    }

    function colorClass(places) {
        if(places<=2) return 'availability--red';
        if(places<=6) return 'availability--yellow';
        return 'availability--green';
    }

    function setState(el,colorClassName,text) {
        COLOR_CLASSES.forEach(function(c) { el.classList.remove(c); });
        if(colorClassName) el.classList.add(colorClassName);
        el.textContent=text;
        el.classList.add('is-ready');
    }

    function initAvailability() {
        var els=document.querySelectorAll('.availability[data-event-date]');
        if(!els.length) return;

        var today=new Date();
        today.setHours(0,0,0,0);

        els.forEach(function(el) {
            var ausgebucht=el.getAttribute('data-event-ausgebucht');

            if(ausgebucht==='true') {
                setState(el,'availability--soldout','keine Plätze mehr verfügbar');
                return;
            }

            var dateStr=el.getAttribute('data-event-date');
            var parts=(dateStr||'').split('-');
            if(parts.length!==3) return;

            var eventDate=new Date(parseInt(parts[0],10),parseInt(parts[1],10)-1,parseInt(parts[2],10));
            eventDate.setHours(0,0,0,0);
            if(isNaN(eventDate.getTime())) return;

            var days=Math.round((eventDate-today)/86400000);
            if(days<0) return;

            var places=computePlaces(days);
            setState(el,colorClass(places),'noch '+places+' Plätze verfügbar');
        });
    }

    if(document.readyState==='loading') {
        document.addEventListener('DOMContentLoaded',initAvailability);
    } else {
        initAvailability();
    }
})();
